import produce from 'immer';
import { find, findIndex } from 'lodash';
import * as types from 'actions/channels/types';

const initialState = {
  isLoading: false,
  data: [],
  lastFocus: null,
  error: null,
  lastEPGUpdateErrorTimestamp: null,
};

export default produce((draft, action) => {
  switch (action.type) {
    case types.FETCH:
      draft.isLoading = true;
      draft.error = null;
      return draft;
    case types.FETCH_SUCCESS:
      draft.isLoading = false;
      draft.data = action.payload.data;
      return draft;
    case types.FETCH_ERROR:
      draft.isLoading = false;
      draft.error = action.payload.error;
      return draft;
    case types.FETCH_EPG_SUCCESS: {
      const { channelId, epg } = action.payload;
      const index = draft.data.findIndex((channel) => channel.id === channelId);

      draft.data[index].epg = epg;
      return draft;
    }
    case types.FETCH_EXTRA_EPG_ITEMS: {
      const { channelId } = action.payload;
      const index = draft.data.findIndex((channel) => channel.id === channelId);

      draft.data[index].isOnLazyload = true;
      return draft;
    }
    case types.FETCH_EXTRA_EPG_ITEMS_SUCCESS: {
      const { channelId, epg, isFirstEpgItemLoaded, isLastEpgItemLoaded } = action.payload;
      const index = draft.data.findIndex((channel) => channel.id === channelId);

      draft.data[index].isOnLazyload = false;
      draft.data[index].epg = epg;
      draft.data[index].isFirstEpgItemLoaded = isFirstEpgItemLoaded;
      draft.data[index].isLastEpgItemLoaded = isLastEpgItemLoaded;
      return draft;
    }
    case types.FETCH_EXTRA_EPG_ITEMS_ERROR: {
      const { channelId } = action.payload;
      const index = draft.data.findIndex((channel) => channel.id === channelId);

      draft.data[index].isOnLazyload = false;
      return draft;
    }
    case types.UPDATE_CURRENT_PROGRAM_SUCCESS: {
      const { programs, ids } = action.payload;
      draft.data = draft.data.map((channel) => {
        const currentProgramUpdate = find(programs, { channelId: channel.id });
        if (currentProgramUpdate) {
          const isDVR = !!channel.tvServices.catchupTv;
          const prevProgramIndex = findIndex(channel.epg, { id: channel.currentProgram.id });
          const currProgramIndex = findIndex(channel.epg, { id: currentProgramUpdate.id });
          channel.currentProgram = currentProgramUpdate;

          if (channel.epg) {
            channel.epg = channel.epg.map((program) => ({ ...program }));
            // Status should be chnaged for EPG/Player correct working
            if (isDVR && prevProgramIndex !== -1) channel.epg[prevProgramIndex].state = 'CATCHUP';
            if (isDVR && currProgramIndex !== -1) channel.epg[currProgramIndex].state = 'LIVE_CATCHUP';
          }
          return channel;
        } else if (ids.includes(channel.id)) {
          // Sometimes EPG could just end, so need to reset "currentProgram" to prevent DDOS
          // https://hootko.atlassian.net/browse/STVWL-579
          channel.currentProgram = null;
        }
        return channel;
      });
      // reset in success case
      draft.lastEPGUpdateErrorTimestamp = null;
      return draft;
    }
    case types.UPDATE_CURRENT_PROGRAM_ERROR: {
      draft.lastEPGUpdateErrorTimestamp = Date.now();
      break;
    }
    case types.TOGGLE_CHANNEL_IN_FAVORITE_STATUS_SUCCESS: {
      const { channelId, favorite } = action.payload;
      const index = draft.data.findIndex((channel) => channel.id === channelId);

      draft.data[index].favorite = favorite;
      return draft;
    }
    case types.TOGGLE_PROGRAM_IN_FAVORITE_STATUS_SUCCESS: {
      const { id, channelId, favorite } = action.payload;
      const channelIndex = draft.data.findIndex((channel) => channel.id === channelId);
      const programIndex = draft.data[channelIndex].epg.findIndex((program) => program.id === id);

      draft.data[channelIndex].epg[programIndex].favorite = favorite;
      return draft;
    }
    case types.RESET_ALL_DATA:
      return { ...initialState };
    default:
    // nothing
  }
}, initialState);
